<template> 
  <div>
    <p id="cash-flow-name">{{analytics.name}}</p>
    <label>
      <select class="date-selector" name="" id="" v-if="analytics.date_filter_enabled" v-model="selectedDate">
        <option :value="date" v-for="(date, index) in dates" :key="index">{{ date }}</option>
      </select>
    </label>
    <table>
      <tr>
        <template v-if="!portfolioView">
          <th :rowspan="showAdditionalData && multiTitles ? 2 : 1">Название</th>
        </template>
        <template v-else>
          <th>Портфель</th>
        </template>
        <template v-if="multiTitles">
          <th v-for="(title, index) in analytics.data.titles" rowspan='1' :colspan='showAdditionalData ? additionalData[index].length : 1' :key="index">{{ title }}</th>
        </template>
        <template v-else-if="showAdditionalData">
          <template v-if="additionalData.length > 0">
            <th v-for="(cohort, index) in additionalData" :key="index">{{ cohort }}</th>
          </template>
          <template v-else>
            <th>Данных нет</th>
          </template>
        </template>
        <template v-else>
          <th>Значение</th>
        </template>
      </tr>
      <tr v-if="showAdditionalData && multiTitles">
        <th v-for="(cohort, indexCohorts) in additionalData.flat()" rowspan='1' :key="indexCohorts">{{ cohort }}</th>
      </tr>
      <template v-if="multiTitles">
        <tr v-for="(record, index) in analytics.data.data" :key="index">
          <td :title="record.name" v-if="record.name.length < 10">{{ record.name }}</td>
          <td :title="record.name" v-else>{{ record.name.substring(0, 11) + '...' }}</td>
          
          <template v-if="showAdditionalData">
            <template v-if="additionalDataType === 'cohorts'">
              <td v-for="cohort in record.cohorts">{{ getFormattedValue(cohort.value) }}</td>
            </template>
            <template v-else-if="additionalDataType === 'reportDates'">
              <td v-for="date in record.dates">{{ getFormattedValue(date.value) }}</td>
            </template>
          </template>

          <template v-else>
            <td v-for="(value, index) in record.values" :key="index">{{ getFormattedValue(value) }}</td>
          </template>
        </tr>
      </template>
      <template v-else-if="showAdditionalData">
        <tr v-for="(record, index) in analytics.data.records" :key="index">
          <td>{{ record.name }}</td>

          <template v-if="additionalDataType === 'cohorts'">
            <template v-if="record.cohorts.length > 0">
              <td v-for="cohort in record.cohorts">{{ getFormattedValue(cohort.value) }}</td>
            </template>
            <template v-else>
              <td>Данных нет</td>
            </template>
          </template>

          
          <template v-else-if="additionalDataType === 'reportDates'">
            <template v-if="record.dates.length > 0">
              <td v-for="date in record.dates">{{ getFormattedValue(date.value) }}</td>
            </template>
            <template v-else>
              <td>Данных нет</td>
            </template>
          </template>

        </tr>
      </template>
      <template v-else>
        <tr v-for="(record, index) in analytics.data.records" :key="index">
          <td>{{ record.name }}</td>
          <td>{{ getFormattedValue(record.value) }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AnalyticsTable',
  props: {
    analytics: Object,
    multiTitles: Boolean,
    portfolioView: Boolean,
    portfolioView: Boolean,
    showAdditionalData: Boolean,
    additionalDataType: String,
    dates: Array,
  },
  data(){
    return {
      numberFormat: new Intl.NumberFormat('us-US', {
        useGrouping: true, 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2
      }),
      selectedDate: null,
    }
  },
  mounted(){
    this.selectedDate = this.dates[0];
  },
  computed:{
    additionalData(){
      if(this.additionalDataType === 'cohorts'){
        return this.analytics.data.cohorts
      }else if (this.additionalDataType === 'reportDates'){
        return this.analytics.data.dates
      }
    }
  },
  methods:{
    getFormattedValue(value){
      return this.numberFormat.format(value)
    },
  },
  watch: {
    selectedDate(date) {
      this.$emit('onDateFilterChange', date)
    },
  },
}
</script>

<style scoped>
.analytics{
  margin-top: 5.2rem;
}

table{
  width: auto;
  min-width: 700px;
  background-color: white;
  border:1px solid black;
}

table, th, td {
  color: #6b6f77;
  border: 10px solid #ebebf5;
  border-collapse: collapse;  
}

th{
  background-color: #c5eaff;
  color: black;
}

th, td {
  padding: 10px;
  width: 200px;
}

td{
  text-align: center;
}

td:first-child{
  text-align: center;
}

#cash-flow-name{
  margin-bottom: 10px;
}

.date-selector{
  margin-bottom: 10px;
}
</style>
  